import axios from 'axios'
import tokenManager from '../utils/token'
import config from './index'

const ConnectionInstance = axios.create({
  baseURL: config('auth.providers.rest.url'),
})

ConnectionInstance.interceptors.request.use(
  async (requestConfig) => {
    const token = tokenManager.getToken()
    if (token && requestConfig?.headers) {
      requestConfig.headers.Authorization = `Bearer ${token}`
    }
    return requestConfig
  },
  (error) => {
    return Promise.reject(error)
  },
)

export default ConnectionInstance
